var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mypage" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("h2", [_vm._v(_vm._s(_vm.$t("myPage.title")))]),
          _c("div", [
            _c(
              "div",
              { staticClass: "fish-info" },
              [
                _vm.fishError
                  ? _c("div", { staticClass: "fish-error" }, [
                      _c("p", { staticClass: "error-message" }, [
                        _vm._v(_vm._s(_vm.fishError)),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "retry-button",
                          on: { click: _vm.retryFetchFishData },
                        },
                        [_vm._v(_vm._s(_vm.$t("myPage.fish.retry")))]
                      ),
                    ])
                  : [
                      !_vm.isFreePlan
                        ? _c("div", { staticClass: "premium-badge" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/icon/premium.png"),
                                width: "24",
                                height: "24",
                                alt: "Premium",
                              },
                            }),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "fish-info-title" }, [
                        _vm._v(_vm._s(_vm.$t("myPage.fish.holdings"))),
                      ]),
                      _c("div", { staticClass: "fish-info-data" }, [
                        _c(
                          "div",
                          { staticClass: "fish-info-data-title" },
                          [
                            _c("img", {
                              staticClass: "fish-info-data-title-icon",
                              attrs: {
                                src: require("@/assets/img/icon/fish_icon.png"),
                                alt: _vm.$t("myPage.fish.iconAlt").toString(),
                              },
                            }),
                            _vm.fishLoading
                              ? _c("span", {
                                  staticClass: "skeleton-text skeleton-amount",
                                })
                              : [_vm._v(_vm._s(_vm.formattedCurrentFish))],
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "fish-info-data-description" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "fish-info-data-description-item",
                              },
                              [
                                _c("div", { staticClass: "fish-category" }, [
                                  _vm._v(_vm._s(_vm.$t("myPage.fish.charged"))),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "fish-value" },
                                  [
                                    _vm.fishLoading
                                      ? _c("span", {
                                          staticClass:
                                            "skeleton-text skeleton-value",
                                        })
                                      : [
                                          _vm._v(
                                            _vm._s(_vm.formattedPrepaidFish)
                                          ),
                                        ],
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "fish-info-data-description-item-plus",
                              },
                              [_c("PlusIcon")],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "fish-info-data-description-item",
                              },
                              [
                                _c("div", { staticClass: "fish-category" }, [
                                  _vm._v(_vm._s(_vm.$t("myPage.fish.bonus"))),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "fish-value" },
                                  [
                                    _vm.fishLoading
                                      ? _c("span", {
                                          staticClass:
                                            "skeleton-text skeleton-value",
                                        })
                                      : [_vm._v(_vm._s(_vm.formattedFreeFish))],
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "fish-info-action" }, [
                        _c("div", { staticClass: "fish-info-action-buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "fish-purchase-button",
                              on: { click: _vm.onClickPurchase },
                            },
                            [
                              _c("PlusIcon"),
                              _vm._v(
                                _vm._s(_vm.$t("myPage.fish.chargeFish")) + " "
                              ),
                            ],
                            1
                          ),
                          _vm.isFreePlan && !_vm.hasPaymentError
                            ? _c(
                                "button",
                                {
                                  staticClass: "upgrade-button",
                                  on: { click: _vm.onClickUpgrade },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/icon/premium.png"),
                                      width: "24",
                                      height: "24",
                                    },
                                  }),
                                  _vm._v(
                                    _vm._s(_vm.$t("myPage.fish.upgrade")) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "fish-info-links" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "fish-link",
                                attrs: { to: "/fish-history" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("myPage.fish.usageHistory"))
                                ),
                              ]
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "fish-link",
                                attrs: { to: { name: "paymentManagement" } },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("myPage.fish.paymentManagement")
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
              ],
              2
            ),
          ]),
          _c("payment-description"),
          _c("my-page-user-info-section"),
          _vm.hasWriterTypeResult
            ? _c("div", { staticClass: "assistant-cat-section" }, [
                _c(
                  "h2",
                  { staticClass: "h2" },
                  [
                    _c("cat-icon", {
                      staticClass: "section-icon",
                      attrs: {
                        size: "small",
                        clickable: false,
                        "writer-type": _vm.selectedCatType,
                      },
                    }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("myPage.assistantCat.title")) + " "
                    ),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "assistant-cat-button",
                    on: { click: _vm.onClickChangeAssistantCat },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("myPage.assistantCat.changeButton")) +
                        " "
                    ),
                  ]
                ),
                _c("p", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("myPage.assistantCat.nicknameLabel"))),
                ]),
                _c("aside", [_vm._v(_vm._s(_vm.selectedCatNickname))]),
                _c("p", { staticClass: "comment" }, [
                  _vm._v(
                    _vm._s(_vm.$t("myPage.assistantCat.nicknameDescription"))
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "assistant-cat-button",
                    on: { click: _vm.onClickChangeNickname },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("myPage.assistantCat.changeNicknameButton")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("myPage.assistantCat.modeLabel"))),
                ]),
                _c("aside", { staticClass: "mode-title" }, [
                  _vm._v(" " + _vm._s(_vm.feedbackManuscriptMode) + " "),
                  _c(
                    "button",
                    {
                      staticClass: "mode-change-button",
                      attrs: { type: "button" },
                      on: { click: _vm.onClickChangeFeedbackManuscriptMode },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("myPage.assistantCat.changeModeButton")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("myPage.assistantCat.summaryModeLabel"))
                  ),
                ]),
                _c("aside", { staticClass: "mode-title" }, [
                  _vm._v(" " + _vm._s(_vm.generateSummaryMode) + " "),
                  _c(
                    "button",
                    {
                      staticClass: "mode-change-button",
                      attrs: { type: "button" },
                      on: { click: _vm.onClickChangeGenerateSummaryMode },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("myPage.assistantCat.changeModeButton")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ])
            : _c("div", { staticClass: "assistant-cat-section" }, [
                _c("h2", { staticClass: "h2" }, [
                  _vm._v(_vm._s(_vm.$t("myPage.assistantCat.noResult.title"))),
                ]),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("myPage.assistantCat.noResult.description"))
                  ),
                ]),
                _c("div", { staticClass: "no-result-btn-wrapper" }, [
                  _c(
                    "button",
                    {
                      staticClass: "assistant-cat-button",
                      on: { click: _vm.onClickWriterTypeIndicator },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "myPage.assistantCat.noResult.takeTestButton"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "assistant-cat-button btn-skip",
                      on: { click: _vm.onClickSkipWriterType },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("myPage.assistantCat.noResult.skipButton")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
          _vm.showAssistantCatDialog
            ? _c("AssistantCatSelectionDialog", {
                attrs: { "assistant-cat-master": _vm.assistantCatMaster },
                on: { close: _vm.onCloseAssistantCatDialog },
              })
            : _vm._e(),
          _vm.showNicknameInputDialog
            ? _c("CatNicknameInputDialog", {
                attrs: {
                  "assistant-cat": _vm.selectedAssistantCat,
                  "initial-nickname": _vm.inputDialogInitialNickname,
                },
                on: {
                  save: _vm.onSaveNickname,
                  cancel: _vm.onCancelNicknameInput,
                },
              })
            : _vm._e(),
          _vm.showNicknameConfirmDialog
            ? _c("CatNicknameConfirmDialog", {
                attrs: {
                  "assistant-cat": _vm.selectedAssistantCat,
                  nickname: _vm.pendingNickname,
                  "is-resetting-to-default": _vm.isResettingNicknameToDefault,
                },
                on: {
                  confirm: _vm.onConfirmNickname,
                  close: _vm.onCloseNicknameConfirm,
                },
              })
            : _vm._e(),
          _vm.showNicknameSuccessDialog
            ? _c("CatNicknameSuccessDialog", {
                attrs: {
                  "assistant-cat": _vm.selectedAssistantCat,
                  "reaction-message": _vm.nicknameReactionMessage,
                },
                on: { ok: _vm.onOkNicknameSuccess },
              })
            : _vm._e(),
          _vm.showSkipConfirmDialog
            ? _c("WriterTypeIndicatorSkipConfirmDialog", {
                on: {
                  close: function ($event) {
                    _vm.showSkipConfirmDialog = false
                  },
                  done: _vm.onSkipConfirmDone,
                },
              })
            : _vm._e(),
          _vm.showFeedbackManuscriptModeDialog
            ? _c("FeedbackManuscriptModeSelectionDialog", {
                attrs: { "assistant-cat-master": _vm.assistantCatMaster },
                on: { close: _vm.onCloseFeedbackManuscriptModeDialog },
              })
            : _vm._e(),
          _vm.showGenerateSummaryModeDialog
            ? _c("GenerateSummaryModeSelectionDialog", {
                attrs: { "assistant-cat-master": _vm.assistantCatMaster },
                on: { close: _vm.onCloseGenerateSummaryModeDialog },
              })
            : _vm._e(),
          _c("div", { staticClass: "theme-settings-section" }, [
            _c("h2", { staticClass: "h2" }, [
              _vm._v(_vm._s(_vm.$t("appTheme.label"))),
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("myPage.themeSettings.description"))),
            ]),
            _c("p", { staticClass: "trial-notice" }, [
              _vm._v(_vm._s(_vm.$t("myPage.themeSettings.trialNotice"))),
            ]),
            _c("div", { staticClass: "theme-dropdown-container" }, [
              _c(
                "select",
                {
                  staticClass: "theme-dropdown",
                  domProps: { value: _vm.appTheme },
                  on: {
                    change: function ($event) {
                      return _vm.onChangeTheme($event)
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "light" } }, [
                    _vm._v(_vm._s(_vm.$t("appTheme.light"))),
                  ]),
                  _c("option", { attrs: { value: "dark" } }, [
                    _vm._v(_vm._s(_vm.$t("appTheme.dark"))),
                  ]),
                  _c("option", { attrs: { value: "system" } }, [
                    _vm._v(_vm._s(_vm.$t("appTheme.system"))),
                  ]),
                ]
              ),
            ]),
            _c("p", { staticClass: "language-label" }, [
              _vm._v(_vm._s(_vm.$t("myPage.languageSettings.title"))),
            ]),
            _c("div", { staticClass: "language-dropdown-container" }, [
              _c(
                "select",
                {
                  staticClass: "theme-dropdown",
                  domProps: { value: _vm.selectedLocale },
                  on: {
                    change: function ($event) {
                      return _vm.onChangeLocale($event)
                    },
                  },
                },
                _vm._l(_vm.localeOptions, function (option) {
                  return _c(
                    "option",
                    { key: option.code, domProps: { value: option.code } },
                    [_vm._v(_vm._s(option.label))]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("h2", { staticClass: "h2" }, [
            _vm._v(_vm._s(_vm.$t("myPage.passwordChange.title"))),
          ]),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("myPage.passwordChange.description"))),
          ]),
          _c(
            "router-link",
            {
              staticClass: "button cancel",
              attrs: { to: { name: "changePassword" } },
            },
            [_vm._v(_vm._s(_vm.$t("myPage.passwordChange.button")))]
          ),
          _c("h2", { staticClass: "h2" }, [
            _vm._v(_vm._s(_vm.$t("myPage.emailChange.title"))),
          ]),
          _c("p", [_vm._v(_vm._s(_vm.$t("myPage.emailChange.description")))]),
          _c(
            "router-link",
            {
              staticClass: "button cancel",
              attrs: { to: { name: "changeEmail" } },
            },
            [_vm._v(_vm._s(_vm.$t("myPage.emailChange.button")))]
          ),
          _c("div", { staticClass: "email-notification-section" }, [
            _c("h2", { staticClass: "h2" }, [
              _vm._v(_vm._s(_vm.$t("myPage.emailNotification.title"))),
            ]),
            _c("div", { staticClass: "email-magazine-row" }, [
              _c("div", { staticClass: "email-magazine-content" }, [
                _c("p", { staticClass: "email-magazine-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("myPage.emailNotification.magazine.title"))
                  ),
                ]),
                _c("p", { staticClass: "email-magazine-description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("myPage.emailNotification.magazine.description")
                    )
                  ),
                ]),
                _c("ul", { staticClass: "email-magazine-list" }, [
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("myPage.emailNotification.magazine.item1"))
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("myPage.emailNotification.magazine.item2"))
                    ),
                  ]),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("myPage.emailNotification.magazine.item3"))
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "email-magazine-options-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "email-magazine-options",
                    class: {
                      disabled:
                        _vm.emailNotificationLoading ||
                        _vm.emailNotificationUpdating,
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "email-magazine-option",
                        class: { "is-disabled": _vm.currentLocale !== "ja" },
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.currentLocale !== "ja" ||
                            _vm.emailNotificationLoading ||
                            _vm.emailNotificationUpdating,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onChangeEmailMagazine(true)
                          },
                        },
                      },
                      [
                        _c("radio-icon", {
                          attrs: {
                            value: "receive",
                            selected: _vm.emailMagazineEnabled
                              ? "receive"
                              : "notReceive",
                            fill: _vm.emailMagazineEnabled
                              ? "var(--color-primary)"
                              : "var(--color-inactive)",
                          },
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("myPage.emailNotification.receive"))
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "email-magazine-option",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.emailNotificationLoading ||
                            _vm.emailNotificationUpdating,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onChangeEmailMagazine(false)
                          },
                        },
                      },
                      [
                        _c("radio-icon", {
                          attrs: {
                            value: "notReceive",
                            selected: _vm.emailMagazineEnabled
                              ? "receive"
                              : "notReceive",
                            fill: !_vm.emailMagazineEnabled
                              ? "var(--color-primary)"
                              : "var(--color-inactive)",
                          },
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("myPage.emailNotification.notReceive")
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm.currentLocale !== "ja"
                  ? _c("p", { staticClass: "email-magazine-japanese-notice" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "myPage.emailNotification.japaneseOnlyNotice"
                            )
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("h2", { staticClass: "h2" }, [
            _vm._v(_vm._s(_vm.$t("myPage.logout.title"))),
          ]),
          _c("p", [_vm._v(_vm._s(_vm.$t("myPage.logout.description")))]),
          _c(
            "button",
            { staticClass: "button cancel", on: { click: _vm.logout } },
            [_vm._v(_vm._s(_vm.$t("myPage.logout.button")))]
          ),
          !_vm.isSchoolPlan
            ? _c("div", [
                _c("h2", { staticClass: "h2" }, [
                  _vm._v(_vm._s(_vm.$t("myPage.accountDeletion.title"))),
                ]),
                _c("p", [
                  _vm._v(
                    " " + _vm._s(_vm.$t("myPage.accountDeletion.description"))
                  ),
                  _c("br"),
                  _c(
                    "span",
                    { staticStyle: { color: "var(--color-warning)" } },
                    [_vm._v(_vm._s(_vm.$t("myPage.accountDeletion.warning")))]
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "button danger",
                    class: { processing: _vm.isProcessing },
                    attrs: { disabled: _vm.isProcessing },
                    on: { click: _vm.onClickDeleteAccount },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("myPage.accountDeletion.button")) +
                        " "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("site-footer", { staticClass: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }